var map = {
	"./header/alle-termine.jpg": 5086,
	"./header/alle-termine@2x.jpg": 5049,
	"./header/familien-konzerte.jpg": 532,
	"./header/familien-konzerte@2x.jpg": 7948,
	"./header/gastspiele.jpg": 6479,
	"./header/gastspiele@2x.jpg": 574,
	"./header/impressum.jpg": 7288,
	"./header/impressum@2x.jpg": 3838,
	"./header/kindergarten-konzerte.jpg": 3364,
	"./header/kindergarten-konzerte@2x.jpg": 1465,
	"./header/kontakt.jpg": 5654,
	"./header/kontakt@2x.jpg": 8884,
	"./header/konzept.jpg": 5554,
	"./header/konzept@2x.jpg": 4763,
	"./header/mini-musik-in-kitas.jpg": 4399,
	"./header/mini-musik-in-kitas@2x.jpg": 8527,
	"./header/netzwerk.jpg": 7547,
	"./header/netzwerk@2x.jpg": 1651,
	"./header/newsletter.jpg": 2852,
	"./header/newsletter@2x.jpg": 9563,
	"./header/partner.jpg": 7041,
	"./header/partner@2x.jpg": 6802,
	"./header/presse.jpg": 4059,
	"./header/presse@2x.jpg": 272,
	"./header/pressebilder.jpg": 3599,
	"./header/pressebilder@2x.jpg": 9921,
	"./header/pressemitteilungen.jpg": 5863,
	"./header/pressemitteilungen@2x.jpg": 9805,
	"./header/programme.jpg": 1428,
	"./header/programme@2x.jpg": 7273,
	"./header/referenzen.jpg": 5582,
	"./header/referenzen@2x.jpg": 1894,
	"./header/team.jpg": 1853,
	"./header/team@2x.jpg": 6230,
	"./header/veranstalter.jpg": 3593,
	"./header/veranstalter@2x.jpg": 9672,
	"./header/verein.jpg": 5208,
	"./header/verein@2x.jpg": 5217,
	"./header/workshops.jpg": 6971,
	"./header/workshops@2x.jpg": 2556,
	"./kater-matze/cd-matze-im-weltall.jpg": 716,
	"./kater-matze/cd-matze-mit-der-blauen-tatze.jpg": 5215,
	"./kater-matze/cd-matze-muetze-und-der-blaue-ball.jpg": 7150,
	"./kater-matze/figur-bossa-baer.jpg": 4825,
	"./kater-matze/figur-leo.jpg": 5421,
	"./kater-matze/figur-matze.jpg": 4409,
	"./kater-matze/figur-muetze.jpg": 2286,
	"./kater-matze/figur-niccolo.jpg": 9361,
	"./kater-matze/figur-swinguru.jpg": 7882,
	"./kater-matze/hg-blau-1-mobile.jpg": 1063,
	"./kater-matze/hg-blau-1.jpg": 2690,
	"./kater-matze/hg-blau-2-mobile.jpg": 2728,
	"./kater-matze/hg-blau-2.jpg": 1816,
	"./kater-matze/hg-grau-1-mobile.jpg": 159,
	"./kater-matze/hg-grau-1.jpg": 4858,
	"./kater-matze/hg-grau-2-mobile.jpg": 3051,
	"./kater-matze/hg-grau-2.jpg": 9397,
	"./kater-matze/hg-wasser-1.png": 8549,
	"./kater-matze/hg-wasser-2.png": 9464,
	"./kater-matze/kater-matze-ausmalbild.jpg": 8985,
	"./kater-matze/kater-matze-booking.jpg": 448,
	"./kater-matze/kater-matze-header.jpg": 1588,
	"./kater-matze/kater-matze-karte.jpg": 762,
	"./kater-matze/kater-matze-medien.jpg": 8791,
	"./kater-matze/kater-matze-musik.jpg": 5361,
	"./kater-matze/klingel-off.jpg": 5223,
	"./kater-matze/klingel-on.jpg": 9662,
	"./kater-matze/matze-band-alex-naumann.jpg": 4128,
	"./kater-matze/matze-band-carolin-roth.jpg": 9549,
	"./kater-matze/matze-band-nikolaus-reichel.jpg": 1544,
	"./kater-matze/matze-band-stephan-staudt.jpg": 7989,
	"./kater-matze/matze-band-tom-reinbrecht.jpg": 7176,
	"./kater-matze/matze-band-uta-sailer.jpg": 3967,
	"./kater-matze/matze-figuren.jpg": 6283,
	"./kater-matze/matze-t-shirt.jpg": 4799,
	"./kater-matze/minikonzert-matze.jpg": 4005,
	"./kater-matze/rahmen-matze-shows.png": 39,
	"./kater-matze/sound-button.png": 5965,
	"./kater-matze/tatze-alex.png": 2188,
	"./kater-matze/tatze-carolin.png": 3262,
	"./kater-matze/tatze-nikolaus.png": 9359,
	"./kater-matze/tatze-stephan.png": 4987,
	"./kater-matze/tatze-tom.png": 6821,
	"./kater-matze/tatze-uta.png": 4521,
	"./layout/adventsverlosung.jpg": 20,
	"./layout/logo.jpg": 5860,
	"./layout/mm_pattern_gray.png": 5255,
	"./layout/mm_pattern_orange.png": 7075,
	"./layout/pressebeauftragte-gesucht.png": 3635,
	"./layout/stern.png": 4153,
	"./mini-musik/mini-musik-familienkonzerte.jpg": 6181,
	"./mini-musik/mini-musik-firmenevents.jpg": 4394,
	"./mini-musik/mini-musik-gastspiele.jpg": 6717,
	"./mini-musik/mini-musik-imagefilm.jpg": 985,
	"./mini-musik/mini-musik-kindergartenkonzerte.jpg": 3570,
	"./mini-musik/mini-musik-matze.jpg": 4773,
	"./mini-musik/mini-musik-sozialprojekt.jpg": 2298,
	"./mini-musik/mini-musik-unterricht.jpg": 2329,
	"./mini-musik/mini-musik-workshops.jpg": 5811,
	"./partner/YelpLogo1.jpg": 4677,
	"./partner/bauermann.png": 4107,
	"./partner/dresdner_musikfestspiele.png": 3646,
	"./partner/familie_muenchen.png": 7633,
	"./partner/gasteig.png": 7933,
	"./partner/junge_ohren.png": 6709,
	"./partner/klassik_info.png": 6232,
	"./partner/kulturgipfel.png": 7912,
	"./partner/musenkuss.png": 9072,
	"./partner/musik_zu_anfassen.png": 7175,
	"./partner/my_city_baby_muenchen.png": 8120,
	"./partner/qype_2.png": 562,
	"./partner/radio_family.png": 8007,
	"./partner/rheingau_musik_festival.png": 9605,
	"./partner/serenade_im_park.png": 4234,
	"./partner/taktik.png": 3127,
	"./partner/tillyproduction.png": 4957,
	"./program/1-der-winter-macht-musik-termin.jpg": 7317,
	"./program/1-der-winter-macht-musik.jpg": 6736,
	"./program/10-eins-zwei-drei-buddelei-termin.jpg": 9493,
	"./program/10-eins-zwei-drei-buddelei.jpg": 8517,
	"./program/11-ritterklang-und-prinzessinnengesang-termin.jpg": 8898,
	"./program/11-ritterklang-und-prinzessinnengesang.jpg": 632,
	"./program/12-ferdinand-der-stier-termin.jpg": 139,
	"./program/12-ferdinand-der-stier.jpg": 7718,
	"./program/13-die-abenteuer-der-kleinen-geige-termin.jpg": 8484,
	"./program/13-die-abenteuer-der-kleinen-geige.jpg": 6098,
	"./program/14-ein-engel-faellt-aus-allen-wolken-termin.jpg": 8553,
	"./program/14-ein-engel-faellt-aus-allen-wolken.jpg": 202,
	"./program/15-im-zauberreich-von-baba-jaga-termin.jpg": 2802,
	"./program/15-im-zauberreich-von-baba-jaga.jpg": 4355,
	"./program/16-matze-mit-der-blauen-tatze-termin.jpg": 8759,
	"./program/16-matze-mit-der-blauen-tatze.jpg": 3038,
	"./program/17-wunder-wandel-weltkonzert-termin.jpg": 2362,
	"./program/17-wunder-wandel-weltkonzert.jpg": 7070,
	"./program/18-auf-dem-jahrmarkt-termin.jpg": 4798,
	"./program/18-auf-dem-jahrmarkt.jpg": 70,
	"./program/19-swing-and-sing-termin.jpg": 9908,
	"./program/19-swing-and-sing.jpg": 7192,
	"./program/2-holzwurmgeschichten-termin.jpg": 410,
	"./program/2-holzwurmgeschichten.jpg": 2983,
	"./program/20-gezupft-wie-gesprungen-termin.jpg": 5743,
	"./program/20-gezupft-wie-gesprungen.jpg": 7965,
	"./program/21-barock-rockt-termin.jpg": 3080,
	"./program/21-barock-rockt.jpg": 1718,
	"./program/22-matze-muetze-und-der-blaue-ball-termin.jpg": 203,
	"./program/22-matze-muetze-und-der-blaue-ball.jpg": 768,
	"./program/23-jetzt-geht-s-rund-termin.jpg": 4001,
	"./program/23-jetzt-geht-s-rund.jpg": 4498,
	"./program/24-spielen-mit-zeit-termin.jpg": 8039,
	"./program/24-spielen-mit-zeit.jpg": 8357,
	"./program/25-die-baerenprinzessin-termin.jpg": 4181,
	"./program/25-die-baerenprinzessin.jpg": 6036,
	"./program/26-klara-und-fabio-termin.jpg": 5618,
	"./program/26-klara-und-fabio.jpg": 640,
	"./program/27-das-tapfere-schneiderlein-termin.jpg": 6357,
	"./program/27-das-tapfere-schneiderlein.jpg": 1,
	"./program/28-hans-im-glueck-termin.jpg": 9687,
	"./program/28-hans-im-glueck.jpg": 543,
	"./program/29-aus-dem-tagebuch-einer-fliege-termin.jpg": 1113,
	"./program/29-aus-dem-tagebuch-einer-fliege.jpg": 293,
	"./program/3-achtung-blechlawine-termin.jpg": 3302,
	"./program/3-achtung-blechlawine.jpg": 896,
	"./program/30-matze-im-weltall-termin.jpg": 6083,
	"./program/30-matze-im-weltall.jpg": 6145,
	"./program/31-avaluna-der-mondvogel-termin.jpg": 3235,
	"./program/31-avaluna-der-mondvogel.jpg": 7427,
	"./program/32-beethoven-packt-aus-termin.jpg": 5234,
	"./program/32-beethoven-packt-aus.jpg": 2475,
	"./program/33-kirschbluete-und-kimono-termin.jpg": 5455,
	"./program/33-kirschbluete-und-kimono.jpg": 5040,
	"./program/34-die-baumretter-abenteuer-am-birkenweiher-termin.jpg": 6378,
	"./program/34-die-baumretter-abenteuer-am-birkenweiher.jpg": 4033,
	"./program/35-felix-fanny-fenchel-ein-geheimnisvolles-trio-termin.jpg": 4253,
	"./program/35-felix-fanny-fenchel-ein-geheimnisvolles-trio.jpg": 6823,
	"./program/36-der-klang-der-baeume-termin.jpg": 3911,
	"./program/36-der-klang-der-baeume.jpg": 5108,
	"./program/37-matze-taucht-ab-termin.jpg": 755,
	"./program/37-matze-taucht-ab.jpg": 3345,
	"./program/4-auf-dem-bauernhof-termin.jpg": 1298,
	"./program/4-auf-dem-bauernhof.jpg": 5348,
	"./program/5-im-zirkus-termin.jpg": 4480,
	"./program/5-im-zirkus.jpg": 4302,
	"./program/6-zazou-die-zauberuhr-termin.jpg": 7209,
	"./program/6-zazou-die-zauberuhr.jpg": 6156,
	"./program/7-schlaf-gut-kleiner-baer-termin.jpg": 1153,
	"./program/7-schlaf-gut-kleiner-baer.jpg": 3495,
	"./program/8-klazwei-kladrei-klavier-termin.jpg": 8173,
	"./program/8-klazwei-kladrei-klavier.jpg": 216,
	"./program/9-anatol-der-trommeltroll-termin.jpg": 7095,
	"./program/9-anatol-der-trommeltroll.jpg": 1899,
	"./referenzen/bayerisches-nationalmuseum.png": 1042,
	"./referenzen/berliner-staatsoper-im-schiller-theater.png": 1914,
	"./referenzen/dresdner-musikfestspiele.png": 6233,
	"./referenzen/interalpen-hotel-tyrol.png": 7624,
	"./referenzen/internationales-gitarrenfestival-saitenspruenge.png": 8543,
	"./referenzen/jugendkulturwerk-muenchen.png": 4377,
	"./referenzen/kleines-theaster-haar.png": 1505,
	"./referenzen/kulturzentrum-gasteig.png": 2114,
	"./referenzen/landeshaupstadt-muenchen-kulturreferat.png": 2857,
	"./referenzen/menschen-in-europa.png": 3272,
	"./referenzen/musenkuss-muenchen.png": 8400,
	"./referenzen/netzwerk-junge-ohren.png": 7046,
	"./referenzen/parktheater-im-kurhaus-goeggingen.png": 8471,
	"./referenzen/rheingau-musik-festival.png": 8730,
	"./referenzen/stadt-dachau.png": 6225,
	"./referenzen/stadt-ravensburg.png": 2070,
	"./referenzen/steinway-and-sons.png": 1991,
	"./referenzen/taktik-werkstatt-fuer-musikvermittlung.png": 689,
	"./slideshow/mini_musik_weihnachten.jpg": 9784,
	"./slideshow/mini_musik_weihnachten@2x.jpg": 3307,
	"./slideshow/slide_01.jpg": 8452,
	"./slideshow/slide_01@2x.jpg": 4907,
	"./slideshow/slide_02.jpg": 262,
	"./slideshow/slide_02@2x.jpg": 5871,
	"./slideshow/slide_03.jpg": 9538,
	"./slideshow/slide_03@2x.jpg": 3601,
	"./slideshow/slide_04.jpg": 6285,
	"./slideshow/slide_04@2x.jpg": 653,
	"./slideshow/slide_05.jpg": 100,
	"./slideshow/slide_05@2x.jpg": 7911,
	"./slideshow/slide_06.jpg": 3733,
	"./slideshow/slide_06@2x.jpg": 8716,
	"./slideshow/slide_07.jpg": 726,
	"./slideshow/slide_07@2x.jpg": 2074,
	"./slideshow/slide_08.jpg": 6258,
	"./slideshow/slide_08@2x.jpg": 6542,
	"./slideshow/slide_09.jpg": 4980,
	"./slideshow/slide_09@2x.jpg": 9832,
	"./team/alex-naumann.jpg": 2625,
	"./team/anastasia-reiber.jpg": 6790,
	"./team/annabelle-meinhold.jpg": 7736,
	"./team/christian-mattick.jpg": 3455,
	"./team/dorothee-binding.jpg": 6340,
	"./team/elisabeth-vogl-mauerhofer.jpg": 6666,
	"./team/ludwig-hahn.jpg": 8921,
	"./team/micaela-czisch.jpg": 1845,
	"./team/sabrina-hausmann.jpg": 2678,
	"./team/sophie-von-jena.jpg": 9084,
	"./team/stephan-lanius.jpg": 1928,
	"./team/uta-sailer.jpg": 8857,
	"./unterricht/unterricht-anastasia-reiber.jpg": 7444,
	"./unterricht/unterricht-dorothee-binding.jpg": 5655,
	"./unterricht/unterricht-elisabeth-vogl-mauerhofer.jpg": 5677,
	"./unterricht/unterricht-sabrina-hausmann.jpg": 2497,
	"./veranstalter/events.jpg": 6485,
	"./veranstalter/festivals.jpg": 1893,
	"./veranstalter/hotels.jpg": 1703,
	"./veranstalter/jazz_fuer_kinder.jpg": 107,
	"./veranstalter/kulturhaeuser.jpg": 2277,
	"./veranstalter/museumskonzerte.jpg": 9457,
	"./veranstalter/open_air.jpg": 627,
	"./veranstalter/schlosskonzerte.jpg": 8261,
	"./veranstalter/theater.jpg": 1184,
	"./veranstalter/wunschkonzepte.jpg": 4839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7375;